import React from 'react';
import { Row, Col, Button, Form } from 'antd';
import { useTranslation } from 'react-i18next';

const ButtonsSociogram = ({
  // onBackButton,
  onNextButton,
}) => {
  const [t] = useTranslation();
  return (
    <Row justify="start">
      <Col span={24} align="end">
        <Form.Item>
          {/* {onBackButton && (
            <Button type="text" onClick={onBackButton}>
              ANTERIOR
            </Button>
          )} */}
          <Button type="primary" htmlType="submit" onClick={onNextButton}>
            {t('pages.data.answerSociogram.buttonText2')}
          </Button>
          {/* <div style={{ width: 70, float: 'right' }}> */}
          {/* <Popconfirm
            placement="leftBottom"
            title={text}
            // onConfirm={onNextButton}
            okText="Sí"
            cancelText="No"
          >
            <Button type="primary" htmlType="submit" onClick={onNextButton}>
              SIGUIENTE
            </Button>
          </Popconfirm> */}
          {/* </div> */}
        </Form.Item>
      </Col>
    </Row>
  );
};

export default ButtonsSociogram;
